import classNames from 'clsx';
import React from 'react';

import type { Tournament } from '@swf/poker';
import { TournamentCard, useMTTHandleRegister } from '@swf/poker';

import styles from './HighlightsItem.scss';

const HighlightsItem: React.FC<{ tournament: Tournament }> = ({ tournament }) => {
  const handleRegisterClick = useMTTHandleRegister(tournament.id, tournament.isEnabled);

  return (
    <TournamentCard
      tournament={tournament}
      className={classNames(styles.card, {
        [styles.highlightDisabled]: !tournament.isEnabled
      })}
      onClick={handleRegisterClick}
    />
  );
};

export default HighlightsItem;
